import { memo } from 'react';

import { Badge, Flex, Heading, Text } from '@/components/core';
import { ExportHeader, SetupRequired } from '@/components/flow';
import { WebhookLogo } from '@/components/logos';
import { toActionId, useGetAction } from '@/hooks/api';
import { isNotConfiguredExport, toString } from '@/utils';

export type WebhookExportNodeContentProps = {
  agentId: string;
  actionId: string;
};

const IWebhookExportNodeContent = ({ agentId, actionId }: WebhookExportNodeContentProps) => {
  const { data: action } = useGetAction(toActionId(actionId));

  return (
    <>
      <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
        <ExportHeader agentId={agentId} actionId={actionId}>
          <WebhookLogo variant="plain" size="lg" />
          <Heading size="lg">Export to Webhook</Heading>
        </ExportHeader>
      </div>
      <div className="flex gap-2 py-2">
        {isNotConfiguredExport(action) ? (
          <SetupRequired />
        ) : (
          <Flex className="items-center gap-2 pt-2">
            <Text className="text-nowrap">Export files to:</Text>
            <Badge variant="plain" className="grow truncate">
              <Text className="truncate">{toString(action?.config?.url)}</Text>
            </Badge>
          </Flex>
        )}
      </div>
    </>
  );
};

export const WebhookExportNodeContent = memo(IWebhookExportNodeContent) as typeof IWebhookExportNodeContent;
